import type { ApolloError } from '@apollo/client';

// Mirrors EKycErrorCode in kyc-api (apps/kyc-api/src/modules/e-kyc/domain/enums/e-kyc.enum.ts).
// Kept in sync by hand - these codes are not part of the GraphQL schema, so codegen can't emit them.
export const EKycErrorCode = {
  ALREADY_COMPLETED: 'ALREADY_COMPLETED',
  CITIZEN_ID_NUMBER_MISMATCH: 'CITIZEN_ID_NUMBER_MISMATCH',
} as const;

export type EKycErrorCode = (typeof EKycErrorCode)[keyof typeof EKycErrorCode];

function hasEKycErrorCode(error: ApolloError, code: EKycErrorCode) {
  return error.graphQLErrors.some((graphQLError) => {
    const details = graphQLError.extensions?.details as
      | { code?: string }
      | { code?: string }[]
      | undefined;

    if (!details) {
      return false;
    }

    if (Array.isArray(details)) {
      return details.some((detail) => detail?.code === code);
    }

    return details.code === code;
  });
}

export function isAlreadyCompletedError(error: ApolloError) {
  return hasEKycErrorCode(error, EKycErrorCode.ALREADY_COMPLETED);
}

export function isCitizenIdMismatchError(error: ApolloError) {
  return hasEKycErrorCode(error, EKycErrorCode.CITIZEN_ID_NUMBER_MISMATCH);
}
